var fs = require('fs-extra');
var path = require('path');
require('ts-node/register/transpile-only');
var tsconfigPath = path.resolve(process.cwd(), './tsconfig.json');

var paths = { "*": [] };

if (fs.existsSync(tsconfigPath)) {
  var tsconfig = fs.readJSONSync(tsconfigPath);
  if (tsconfig.compilerOptions != null && tsconfig.compilerOptions.paths != null) {
    Object.assign(paths, tsconfig.compilerOptions.paths);
  }
}
paths["*"] = [
  "node_modules/*",
].concat(paths["*"]);

require('tsconfig-paths').register({
  baseUrl: "./",
  paths: paths,
});


var babelConfig;
var projectBabelConfigPath = path.resolve(process.cwd(), '.babelrc');
if (fs.existsSync(projectBabelConfigPath)) {
  babelConfig = fs.readJSONSync(projectBabelConfigPath);
} else {
  babelConfig = {
    passPerPreset: true,
    presets: [
      [require.resolve('@babel/preset-env'), {
        modules: 'commonjs',
        targets: {
          node: 'current'
        },
        useBuiltIns: 'usage'
      }]
    ],
    plugins: [
      [require.resolve('@babel/plugin-transform-runtime'), {
        regenerator: true
      }],
      require.resolve('babel-plugin-dynamic-import-node'),
      require.resolve('@babel/plugin-proposal-class-properties'),
      require.resolve('@babel/plugin-proposal-object-rest-spread')
    ],
    ignore: [
      __dirname,
      path.resolve(__dirname, "node_modules"),
      path.resolve(process.cwd(), 'node_modules'),
      path.resolve(process.cwd(), 'build'),
      path.resolve(process.cwd(), 'dist')
    ]
  };
}
require('@babel/register')(Object.assign({}, babelConfig, {
  babelrc: false,
  extensions: ['.js', '.jsx', '.ts', '.tsx'],
}));
